import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CreateFMEAInput, CreateFMEAOutput } from '@/types';
import { FactoryPsHttpSSE, type PsHttpSSE } from '@patsnap-utils/sse';

export const CreateApi = Symbol('CreateApi');

export interface CreateApi {
    createFMEA(input: CreateFMEAInput): Promise<CreateFMEAOutput>
    getProgressStream<T>(fmea_id: string): PsHttpSSE<T>
}

@injectable()
export class CreateApiImpl extends PsHttpService implements CreateApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    createFMEA(input: CreateFMEAInput): Promise<CreateFMEAOutput> {
        return this.post<PatSnapCommonResponseData<CreateFMEAOutput>>({
            url: '/fmea/create',
            data: input,
        }).then((res) => {
            return res.data as CreateFMEAOutput
        });
    }

    @inject(FactoryPsHttpSSE)
    private _factorySsePsHttp!: FactoryPsHttpSSE;

    getProgressStream<T>(fmea_id: string): PsHttpSSE<T> {
        return this._factorySsePsHttp<T>().init({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/sse/fmea/analyze`,
            data: {
                fmea_id,
            },
            hasFinalMessage: (data) => !!data.analyze_step_list,
        })
    }
}
